import React from "react";
import { useLanguage } from "../../i18n/LanguageContext";

// ============================================================
// WRONG QUESTION HOME PAGE
//
// Wrong Question V2
//
// Source of truth:
// question_user_progress
//
// This page does NOT use the legacy local-cache
// Wrong Question system.
// ============================================================

export default function WrongQuestionHomePage({
  summary,
  loading,
  startDueReview,
  startActivePractice,
  goBack,
  styles,
}) {
  const { t } = useLanguage();

  // =========================================================
  // SAFE SUMMARY VALUES
  // =========================================================

  const totalWrong =
    summary?.totalWrong ?? 0;

  const activeWrong =
    summary?.activeWrong ?? 0;

  const dueForReview =
    summary?.dueForReview ?? 0;

  const masteredWrong =
    summary?.masteredWrong ?? 0;

  const totalIncorrectAttempts =
    summary?.totalIncorrectAttempts ?? 0;


  // =========================================================
  // LOADING
  // =========================================================

  if (loading) {
    return (
      <div>
        <button
          onClick={goBack}
          style={styles.backButton}
        >
          ← {t("practice.back")}
        </button>

        <h2>
          {t("wrongQuestion.title")}
        </h2>

        <div style={styles.emptyBox}>
          {t("wrongQuestion.loading")}
        </div>
      </div>
    );
  }


  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div>

      {/* =====================================================
          HEADER
      ===================================================== */}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
          alignItems: "flex-start",
          flexWrap: "wrap",
        }}
      >
        <div>
          <div
            style={{
              fontSize: "13px",
              fontWeight: "700",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
              opacity: 0.65,
              marginBottom: "8px",
            }}
          >
            {t("wrongQuestion.center")}
          </div>

          <h2
            style={{
              marginTop: 0,
              marginBottom: "10px",
            }}
          >
            {t("wrongQuestion.heroTitle")}
          </h2>

          <p
            style={{
              marginTop: 0,
              maxWidth: "760px",
              lineHeight: 1.6,
              opacity: 0.8,
            }}
          >
            {t("wrongQuestion.heroDesc")}
          </p>
        </div>

        <button
          onClick={goBack}
          style={styles.secondaryButton}
        >
          {t("practice.back")}
        </button>
      </div>


      {/* =====================================================
          SUMMARY
      ===================================================== */}

      <div
        style={{
          display: "grid",

          gridTemplateColumns:
            "repeat(auto-fit, minmax(150px, 1fr))",

          gap: "12px",

          marginTop: "28px",

          marginBottom: "18px",
        }}
      >

        {/* QUESTIONS MISSED */}

        <div style={styles.card}>
          <div
            style={{
              fontSize: "30px",
              fontWeight: "700",
              marginBottom: "6px",
            }}
          >
            {totalWrong}
          </div>

          <div>
            {t("wrongQuestion.questionsMissed")}
          </div>
        </div>


        {/* NEED PRACTICE */}

        <div style={styles.card}>
          <div
            style={{
              fontSize: "30px",
              fontWeight: "700",
              marginBottom: "6px",
            }}
          >
            {activeWrong}
          </div>

          <div>
            {t("wrongQuestion.needPractice")}
          </div>
        </div>


        {/* DUE NOW */}

        <div style={styles.card}>
          <div
            style={{
              fontSize: "30px",
              fontWeight: "700",
              marginBottom: "6px",
            }}
          >
            {dueForReview}
          </div>

          <div>
            {t("wrongQuestion.dueNow")}
          </div>
        </div>


        {/* MASTERED */}

        <div style={styles.card}>
          <div
            style={{
              fontSize: "30px",
              fontWeight: "700",
              marginBottom: "6px",
            }}
          >
            {masteredWrong}
          </div>

          <div>
            {t("wrongQuestion.mastered")}
          </div>
        </div>

      </div>


      {/* =====================================================
          TOTAL INCORRECT ATTEMPTS
      ===================================================== */}

      <div
        style={{
          marginBottom: "26px",
          fontSize: "14px",
          opacity: 0.75,
        }}
      >
        {t("wrongQuestion.totalIncorrectAttempts")}:{" "}
        <strong>
          {totalIncorrectAttempts}
        </strong>
      </div>


      {/* =====================================================
          NO WRONG QUESTIONS
      ===================================================== */}

      {totalWrong === 0 ? (

        <div style={styles.card}>
          <h3>
            {t("wrongQuestion.noWrongQuestions")}
          </h3>

          <p
            style={{
              lineHeight: 1.6,
            }}
          >
            {t("wrongQuestion.noWrongQuestionsDesc")}
          </p>
        </div>

      ) : (

        <>
          {/* =================================================
              TWO PRACTICE OPTIONS
          ================================================= */}

          <div
            style={{
              display: "grid",

              gridTemplateColumns:
                "repeat(auto-fit, minmax(300px, 1fr))",

              gap: "22px",

              alignItems: "stretch",
            }}
          >

            {/* ===============================================
                REVIEW DUE QUESTIONS
            =============================================== */}

            <div
              style={{
                ...styles.card,
                display: "flex",
                flexDirection: "column",
                minHeight: "430px",
                position: "relative",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "12px",
                  alignItems: "flex-start",
                  marginBottom: "18px",
                }}
              >
                <div
                  style={{
                    width: "52px",
                    height: "52px",
                    borderRadius: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "26px",
                    backgroundColor: "#eff6ff",
                  }}
                >
                  🕒
                </div>

                <div
                  style={{
                    padding: "6px 12px",
                    borderRadius: "999px",
                    fontSize: "11px",
                    fontWeight: "700",
                    letterSpacing: "1px",
                    backgroundColor: "#dbeafe",
                    color: "#1d4ed8",
                  }}
                >
                  {t("wrongQuestion.recommended")}
                </div>
              </div>


              <h3
                style={{
                  marginTop: 0,
                  marginBottom: "10px",
                }}
              >
                {t("wrongQuestion.reviewDueQuestions")}
              </h3>


              <p
                style={{
                  marginTop: 0,
                  lineHeight: 1.6,
                  opacity: 0.8,
                }}
              >
                {t("wrongQuestion.reviewDueDesc")}
              </p>


              <div
                style={{
                  marginTop: "16px",
                  lineHeight: 1.9,
                  opacity: 0.85,
                }}
              >
                <div>
                  ✓ {t("wrongQuestion.reviewDueFeature1")}
                </div>

                <div>
                  ✓ {t("wrongQuestion.reviewDueFeature2")}
                </div>

                <div>
                  ✓ {t("wrongQuestion.reviewDueFeature3")}
                </div>

                <div>
                  ✓ {t("wrongQuestion.reviewDueFeature4")}
                </div>
              </div>


              <div
                style={{
                  marginTop: "auto",
                  paddingTop: "24px",
                }}
              >
                <div
                  style={{
                    marginBottom: "14px",
                    fontWeight: "600",
                  }}
                >
                  {dueForReview > 0 ? (
                    <>
                      {dueForReview}{" "}
                      {dueForReview === 1
                        ? t("wrongQuestion.questionReadyNow")
                        : t("wrongQuestion.questionsReadyNow")}
                    </>
                  ) : (
                    <>
                      {t("wrongQuestion.caughtUp")}
                    </>
                  )}
                </div>


                <button
                  onClick={startDueReview}
                  disabled={
                    dueForReview === 0
                  }
                  style={{
                    ...styles.primaryButton,

                    ...(dueForReview === 0
                      ? {
                          opacity: 0.45,
                          cursor:
                            "not-allowed",
                        }
                      : {}),
                  }}
                >
                  {dueForReview > 0
                    ? t("wrongQuestion.startDueReview")
                    : t("wrongQuestion.nothingDue")}
                </button>


                <div
                  style={{
                    marginTop: "9px",
                    fontSize: "13px",
                    opacity: 0.65,
                  }}
                >
                  {t("wrongQuestion.dueQuestionsPerRound")}
                </div>
              </div>
            </div>


            {/* ===============================================
                PRACTICE WRONG QUESTIONS
            =============================================== */}

            <div
              style={{
                ...styles.card,
                display: "flex",
                flexDirection: "column",
                minHeight: "430px",
              }}
            >
              <div
                style={{
                  width: "52px",
                  height: "52px",
                  borderRadius: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "26px",
                  backgroundColor: "#f8fafc",
                  marginBottom: "18px",
                }}
              >
                🔁
              </div>


              <h3
                style={{
                  marginTop: 0,
                  marginBottom: "10px",
                }}
              >
                {t("wrongQuestion.practiceWrongQuestions")}
              </h3>


              <p
                style={{
                  marginTop: 0,
                  lineHeight: 1.6,
                  opacity: 0.8,
                }}
              >
                {t("wrongQuestion.practiceWrongDesc")}
              </p>


              <div
                style={{
                  marginTop: "16px",
                  lineHeight: 1.9,
                  opacity: 0.85,
                }}
              >
                <div>
                  ✓ {t("wrongQuestion.practiceFeature1")}
                </div>

                <div>
                  ✓ {t("wrongQuestion.practiceFeature2")}
                </div>

                <div>
                  ✓ {t("wrongQuestion.practiceFeature3")}
                </div>

                <div>
                  ✓ {t("wrongQuestion.practiceFeature4")}
                </div>
              </div>


              <div
                style={{
                  marginTop: "auto",
                  paddingTop: "24px",
                }}
              >
                <div
                  style={{
                    marginBottom: "14px",
                    fontWeight: "600",
                  }}
                >
                  {activeWrong > 0 ? (
                    <>
                      {activeWrong}{" "}
                      {activeWrong === 1
                        ? t("wrongQuestion.questionNeedPractice")
                        : t("wrongQuestion.questionsNeedPractice")}
                    </>
                  ) : (
                    <>
                      {t("wrongQuestion.noActiveWrongQuestions")}
                    </>
                  )}
                </div>


                <button
                  onClick={
                    startActivePractice
                  }
                  disabled={
                    activeWrong === 0
                  }
                  style={{
                    ...styles.secondaryButton,

                    ...(activeWrong === 0
                      ? {
                          opacity: 0.45,
                          cursor:
                            "not-allowed",
                        }
                      : {}),
                  }}
                >
                  {t("wrongQuestion.practiceWrongQuestions")}
                </button>


                <div
                  style={{
                    marginTop: "9px",
                    fontSize: "13px",
                    opacity: 0.65,
                  }}
                >
                  {t("wrongQuestion.practiceBeforeDue")}
                </div>
              </div>
            </div>

          </div>


          {/* =================================================
              IMPORTANT DIFFERENCE
          ================================================= */}

          <div
            style={{
              ...styles.card,
              marginTop: "22px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "14px",
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  fontSize: "24px",
                }}
              >
                💡
              </div>

              <div>
                <h3
                  style={{
                    marginTop: 0,
                    marginBottom: "8px",
                  }}
                >
                  {t("wrongQuestion.whichChoose")}
                </h3>

                <div
                  style={{
                    lineHeight: 1.7,
                    opacity: 0.8,
                  }}
                >
                  <div style={{ marginBottom: "10px" }}>
                    <strong>
                      {t("wrongQuestion.reviewDueQuestions")}
                    </strong>{" "}
                    {t("wrongQuestion.whichChooseBefore")}
                  </div>

                  <div>
                    <strong>
                      {t("wrongQuestion.practiceWrongQuestions")}
                    </strong>{" "}
                    {t("wrongQuestion.whichChooseAfter")}
                  </div>
                </div>
              </div>
            </div>
          </div>


          {/* =================================================
              HOW WRONG QUESTIONS WORKS
          ================================================= */}

          <div
            style={{
              ...styles.card,
              marginTop: "22px",
            }}
          >
            <h3
              style={{
                marginTop: 0,
                marginBottom: "20px",
              }}
            >
              {t("wrongQuestion.howItWorks")}
            </h3>


            <div
              style={{
                display: "grid",

                gridTemplateColumns:
                  "repeat(auto-fit, minmax(200px, 1fr))",

                gap: "18px",
              }}
            >

              {/* STEP 1 */}

              <div>
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    opacity: 0.55,
                    marginBottom: "6px",
                  }}
                >
                  {t("wrongQuestion.step1")}
                </div>

                <div
                  style={{
                    fontWeight: "700",
                    marginBottom: "6px",
                  }}
                >
                  {t("wrongQuestion.step1Title")}
                </div>

                <div
                  style={{
                    lineHeight: 1.6,
                    opacity: 0.75,
                  }}
                >
                  {t("wrongQuestion.step1Desc")}
                </div>
              </div>


              {/* STEP 2 */}

              <div>
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    opacity: 0.55,
                    marginBottom: "6px",
                  }}
                >
                  {t("wrongQuestion.step2")}
                </div>

                <div
                  style={{
                    fontWeight: "700",
                    marginBottom: "6px",
                  }}
                >
                  {t("wrongQuestion.step2Title")}
                </div>

                <div
                  style={{
                    lineHeight: 1.6,
                    opacity: 0.75,
                  }}
                >
                  {t("wrongQuestion.step2Desc")}
                </div>
              </div>


              {/* STEP 3 */}

              <div>
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    opacity: 0.55,
                    marginBottom: "6px",
                  }}
                >
                  {t("wrongQuestion.step3")}
                </div>

                <div
                  style={{
                    fontWeight: "700",
                    marginBottom: "6px",
                  }}
                >
                  {t("wrongQuestion.step3Title")}
                </div>

                <div
                  style={{
                    lineHeight: 1.6,
                    opacity: 0.75,
                  }}
                >
                  {t("wrongQuestion.step3Desc")}
                </div>
              </div>


              {/* STEP 4 */}

              <div>
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    opacity: 0.55,
                    marginBottom: "6px",
                  }}
                >
                  {t("wrongQuestion.step4")}
                </div>

                <div
                  style={{
                    fontWeight: "700",
                    marginBottom: "6px",
                  }}
                >
                  {t("wrongQuestion.step4Title")}
                </div>

                <div
                  style={{
                    lineHeight: 1.6,
                    opacity: 0.75,
                  }}
                >
                  {t("wrongQuestion.step4Desc")}
                </div>
              </div>

            </div>
          </div>
        </>
      )}

    </div>
  );
}